import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { LocationsTranslationCounter } from '@recruitee/locations-types';
import { Scope } from '@recruitee/ngrx';

@Injectable({ providedIn: 'root' })
export class LocationsTranslationCountersHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(scope: Scope): Observable<LocationsTranslationCounter[]> {
    return this.httpApi
      .get(`/locations/translation_counters`, { scope })
      .pipe(map(response => response.translationsCounters));
  }
}
